import React from "react";
import {format} from "currency"
export default function Currency({value}){
	return <>
		{format(value)}
	</>;
}